import { render, staticRenderFns } from "./courseTime_pie.vue?vue&type=template&id=35260b50&scoped=true&"
import script from "./courseTime_pie.vue?vue&type=script&lang=js&"
export * from "./courseTime_pie.vue?vue&type=script&lang=js&"
import style0 from "./courseTime_pie.vue?vue&type=style&index=0&id=35260b50&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35260b50",
  null
  
)

export default component.exports